module.exports = __webpack_public_path__ + "img/app-download.f8f1b97c.png";